const _DataTransferComponentHandler = (function () {
    return {
        // Public functions
        init: function () {
            const body = $('body');
            $('[data-app-data_transfer]').each(function () {
                const name = $(this).attr('data-app-data_transfer');
                const sourceTable = $(this).find('[data-app-data_transfer_table="source"]');
                const destinationTable = $(this).find('[data-app-data_transfer_table="destination"]');
                window.handleCheckbox(sourceTable.DataTable(), false);
                window.handleCheckbox(destinationTable.DataTable(), false);
                const syncInputs = () => {
                    const inputs = $(this).find('[data-app-inputs]');
                    inputs.empty();
                    const checkboxes = destinationTable.DataTable().$('[data-app-value]');
                    for (const checkbox of checkboxes) {
                        const value = $(checkbox).attr('data-app-value');
                        inputs.append(`<input type="hidden" name="${name}[]" value="${value}" />`);
                    }
                };
                const syncButtonStates = () => {
                    $('[data-app-move_to="source"]').attr('disabled', (destinationTable.DataTable().$('input[type="checkbox"]:checked')
                        .length === 0));
                    $('[data-app-move_to="destination"]').attr('disabled', (sourceTable.DataTable().$('input[type="checkbox"]:checked')
                        .length === 0));
                };
                $(this).on('click', '[data-app-data_transfer_table] tbody tr', function (e) {
                    if ($(e.target).is('input[type="checkbox"]')) {
                        return;
                    }
                    const checkbox = $(this).find('input[type="checkbox"]');
                    checkbox.prop('checked', !checkbox.is(':checked'));
                    checkbox.trigger('change');
                });
                $(this).on('change', '[data-app-data_transfer_table] input[type="checkbox"]', function () {
                    const row = $(this).closest('tr');
                    if ($(this).is(':checked')) {
                        row.addClass('selected');
                    }
                    else {
                        row.removeClass('selected');
                    }
                    syncButtonStates();
                });
                syncInputs();
                syncButtonStates();
                $(this).on('click', '[data-app-move_to="destination"]', function () {
                    const selectedRows = sourceTable
                        .DataTable()
                        .$('input[type="checkbox"]:checked')
                        .closest('tr');
                    selectedRows.each(function () {
                        const row = $(this);
                        const addRow = sourceTable.DataTable().row(row);
                        destinationTable.DataTable().row.add(addRow.data());
                        addRow.remove();
                    });
                    sourceTable.DataTable().draw();
                    destinationTable.DataTable().draw();
                    syncInputs();
                    syncButtonStates();
                });
                $(this).on('click', '[data-app-move_to="source"]', function () {
                    const selectedRows = destinationTable
                        .DataTable()
                        .$('input[type="checkbox"]:checked')
                        .closest('tr');
                    selectedRows.each(function () {
                        const row = $(this);
                        const addRow = destinationTable.DataTable().row(row);
                        sourceTable.DataTable().row.add(addRow.data());
                        addRow.remove();
                    });
                    sourceTable.DataTable().draw();
                    destinationTable.DataTable().draw();
                    syncInputs();
                    syncButtonStates();
                });
            });
        },
    };
})();
window.DataTransferComponentHandler = _DataTransferComponentHandler;
export {};
